module.exports = __webpack_public_path__ + "img/3.15754f6f.png";